import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import "./LoginBtn.css";
import Login from "../../../CustomComponents/Login/Login";
import AgentLogin from "./AgentLogin";
import CustomerLogin from "./CustomerLogin";
import VendorLogin from "./VendorLogin";

function NewUILoginBtn({ dontShowCustomerDetail = false }) {
  const [loginDetails, setLoginDetails] = useState(false);
  const handleOnClickLogIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoginDetails(!loginDetails);
  };
  const accountLoginRef = useRef(null);
  const [loginPopup, setLoginPopup] = useState();

  useEffect(() => {
    if (loginPopup) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [loginPopup]);

  const handleOnClickLoginBtn = () => {
    setLoginPopup(true);
  };

  const handleClose = () => {
    setLoginPopup(false);
  };

  // useEffect(() => {
  //     if (loginPopup) {
  //         document.body.style.overflow = "hidden";
  //     } else {
  //         document.body.style.overflow = "auto";
  //     }
  // }, [loginPopup]);

  const handleClickOutside = (event) => {
    //   if (accountDetailsRef.current && !accountDetailsRef.current.contains(event.target)) {
    //     setAccountDetails(false);
    //   }
    if (
      accountLoginRef.current &&
      !accountLoginRef.current.contains(event.target)
    ) {
      setLoginDetails(false);
    }
  };

  useEffect(() => {
    // Attach the click event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Cleanup the event listener on component unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen(!isOpen);
  };

  const [isCustomerOpen, setIsCustomerOpen] = useState(false);

  const toggleSliderCustomer = () => {
    setIsCustomerOpen(!isCustomerOpen);
  };
  const [isVendorOpen, setIsVendorOpen] = useState(false);

  const toggleSliderVendor = () => {
    setIsVendorOpen(!isVendorOpen);
  };

  return (
    //
    <>
      <div
        onClick={handleOnClickLogIn}
        className="cursor_pointer relative"
        // style={{ position: "relative", top: "0", right: "0" }}
        ref={accountLoginRef}
      >
        <div className="new_ui_login_btn ">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_5983_6845"
              style={{ maskType: "alpha" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="20"
              height="20"
            >
              <rect width="20" height="20" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_5983_6845)">
              <path
                d="M5.01909 14.4101C5.72742 13.8846 6.49909 13.4695 7.33409 13.1649C8.16895 12.8605 9.05756 12.7083 9.99992 12.7083C10.9423 12.7083 11.8309 12.8605 12.6658 13.1649C13.5008 13.4695 14.2724 13.8846 14.9808 14.4101C15.4988 13.8407 15.9093 13.1815 16.2122 12.4326C16.5151 11.6837 16.6666 10.8728 16.6666 9.99992C16.6666 8.1527 16.0173 6.57978 14.7187 5.28117C13.4201 3.98256 11.8471 3.33325 9.99992 3.33325C8.1527 3.33325 6.57978 3.98256 5.28117 5.28117C3.98256 6.57978 3.33325 8.1527 3.33325 9.99992C3.33325 10.8728 3.48471 11.6837 3.78763 12.4326C4.09054 13.1815 4.50103 13.8407 5.01909 14.4101ZM9.99992 10.6249C9.23922 10.6249 8.5977 10.3637 8.07534 9.84117C7.55283 9.31881 7.29158 8.67728 7.29158 7.91658C7.29158 7.15589 7.55283 6.51436 8.07534 5.992C8.5977 5.4695 9.23922 5.20825 9.99992 5.20825C10.7606 5.20825 11.4021 5.4695 11.9245 5.992C12.447 6.51436 12.7083 7.15589 12.7083 7.91658C12.7083 8.67728 12.447 9.31881 11.9245 9.84117C11.4021 10.3637 10.7606 10.6249 9.99992 10.6249ZM9.99992 17.9166C8.90061 17.9166 7.86936 17.7098 6.90617 17.2964C5.94297 16.8829 5.10513 16.3198 4.39263 15.6072C3.67999 14.8947 3.11693 14.0569 2.70346 13.0937C2.28999 12.1305 2.08325 11.0992 2.08325 9.99992C2.08325 8.90061 2.28999 7.86936 2.70346 6.90617C3.11693 5.94297 3.67999 5.10513 4.39263 4.39263C5.10513 3.67999 5.94297 3.11693 6.90617 2.70346C7.86936 2.28999 8.90061 2.08325 9.99992 2.08325C11.0992 2.08325 12.1305 2.28999 13.0937 2.70346C14.0569 3.11693 14.8947 3.67999 15.6072 4.39263C16.3198 5.10513 16.8829 5.94297 17.2964 6.90617C17.7098 7.86936 17.9166 8.90061 17.9166 9.99992C17.9166 11.0992 17.7098 12.1305 17.2964 13.0937C16.8829 14.0569 16.3198 14.8947 15.6072 15.6072C14.8947 16.3198 14.0569 16.8829 13.0937 17.2964C12.1305 17.7098 11.0992 17.9166 9.99992 17.9166Z"
                fill=""
              />
            </g>
          </svg>
          <button className="Login-text-hide">Log in</button>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            // style={{ margin: "0 0 0 3px" }}
            style={{
              margin: "0 0 0 3px",
              transform: loginDetails ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease-in-out",
            }}
          >
            <mask
              id="mask0_5983_6849"
              style={{ maskType: "alpha" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="14"
              height="14"
            >
              <rect
                y="14"
                width="14"
                height="14"
                transform="rotate(-90 0 14)"
                fill="#D9D9D9"
              />
            </mask>
            <g mask="url(#mask0_5983_6849)">
              <path
                d="M6.99982 8.64202L11.3939 4.24791C11.5098 4.13202 11.6463 4.07554 11.8033 4.07845C11.9604 4.08147 12.0969 4.14092 12.2128 4.25681C12.3287 4.37279 12.3866 4.50929 12.3866 4.66631C12.3866 4.82332 12.3287 4.95982 12.2128 5.07581L7.74693 9.55056C7.64144 9.65604 7.52327 9.73421 7.39241 9.78506C7.26155 9.8359 7.13069 9.86133 6.99983 9.86133C6.86896 9.86133 6.7381 9.8359 6.60724 9.78506C6.47638 9.73421 6.35821 9.65604 6.25272 9.55056L1.77783 5.07581C1.66194 4.95982 1.6055 4.82181 1.60851 4.66179C1.61153 4.50176 1.67098 4.3638 1.78687 4.24791C1.90276 4.13202 2.03926 4.07408 2.19637 4.07408C2.35338 4.07408 2.48983 4.13202 2.60572 4.24791L6.99982 8.64202Z"
                fill=""
              />
            </g>
          </svg>
        </div>
        {loginDetails && (
          <div className="accountDetails">
            <Link
              className="flex_align_center justify_content_between"
              // onClick={toggleSlider}
              to="/login/agent"
            >
              {/* <span className="supportSvg" style={{ height: "30px" }}>
                <svg
                  className="m_0"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_3886_4170"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  >
                    <rect width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_3886_4170)">
                    <path
                      d="M4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V9C2 8.45 2.19583 7.97917 2.5875 7.5875C2.97917 7.19583 3.45 7 4 7H9V4C9 3.45 9.19583 2.97917 9.5875 2.5875C9.97917 2.19583 10.45 2 11 2H13C13.55 2 14.0208 2.19583 14.4125 2.5875C14.8042 2.97917 15 3.45 15 4V7H20C20.55 7 21.0208 7.19583 21.4125 7.5875C21.8042 7.97917 22 8.45 22 9V20C22 20.55 21.8042 21.0208 21.4125 21.4125C21.0208 21.8042 20.55 22 20 22H4ZM4 20H20V9H15C15 9.55 14.8042 10.0208 14.4125 10.4125C14.0208 10.8042 13.55 11 13 11H11C10.45 11 9.97917 10.8042 9.5875 10.4125C9.19583 10.0208 9 9.55 9 9H4V20ZM6 18H12V17.55C12 17.2667 11.9208 17.0042 11.7625 16.7625C11.6042 16.5208 11.3833 16.3333 11.1 16.2C10.7667 16.05 10.4292 15.9375 10.0875 15.8625C9.74583 15.7875 9.38333 15.75 9 15.75C8.61667 15.75 8.25417 15.7875 7.9125 15.8625C7.57083 15.9375 7.23333 16.05 6.9 16.2C6.61667 16.3333 6.39583 16.5208 6.2375 16.7625C6.07917 17.0042 6 17.2667 6 17.55V18ZM14 16.5H18V15H14V16.5ZM9 15C9.41667 15 9.77083 14.8542 10.0625 14.5625C10.3542 14.2708 10.5 13.9167 10.5 13.5C10.5 13.0833 10.3542 12.7292 10.0625 12.4375C9.77083 12.1458 9.41667 12 9 12C8.58333 12 8.22917 12.1458 7.9375 12.4375C7.64583 12.7292 7.5 13.0833 7.5 13.5C7.5 13.9167 7.64583 14.2708 7.9375 14.5625C8.22917 14.8542 8.58333 15 9 15ZM14 13.5H18V12H14V13.5ZM11 9H13V4H11V9Z"
                      fill="#1C1B1F"
                    />
                  </g>
                </svg>
              </span> */}
              <span className="text_left">
                <strong>As Travel Partner</strong>{" "}
                <small
                  style={{ color: "rgb(144 144 144)", lineHeight: "normal" }}
                  className="block"
                >
                  Login Your Partner Account
                </small>
              </span>
              <svg
                width="17"
                height="17"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_6831_12431"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="17"
                  height="17"
                >
                  <rect width="15" height="15" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_6831_12431)">
                  <path
                    d="M10.3919 7.96839H3.28125C3.14823 7.96839 3.03687 7.92349 2.94719 7.8337C2.8574 7.74401 2.8125 7.63266 2.8125 7.49964C2.8125 7.36662 2.8574 7.25526 2.94719 7.16558C3.03687 7.07578 3.14823 7.03089 3.28125 7.03089H10.3919L7.16109 3.80011C7.06818 3.70719 7.02229 3.59844 7.02344 3.47386C7.02469 3.34927 7.07375 3.23849 7.17063 3.14151C7.2676 3.05099 7.3774 3.00412 7.5 3.00089C7.6226 2.99766 7.7324 3.04453 7.82938 3.14151L11.792 7.10417C11.8506 7.16271 11.8918 7.22443 11.9158 7.28933C11.9398 7.35422 11.9519 7.42433 11.9519 7.49964C11.9519 7.57495 11.9398 7.64505 11.9158 7.70995C11.8918 7.77485 11.8506 7.83657 11.792 7.89511L7.82938 11.8578C7.74281 11.9443 7.63563 11.9886 7.50781 11.9906C7.38 11.9926 7.2676 11.9483 7.17063 11.8578C7.07375 11.7608 7.02531 11.6494 7.02531 11.5237C7.02531 11.3979 7.07375 11.2865 7.17063 11.1895L10.3919 7.96839Z"
                    fill="#333333"
                  />
                </g>
              </svg>
            </Link>
            {/* {!dontShowCustomerDetail && ( */}
            <Link
              className="flex_align_center  justify_content_between"
              // to=""
              onClick={toggleSliderCustomer}
              // onClick={handleOnClickLoginBtn}
            >
              {/* <span className="supportSvg">
                <svgre
                  className="m_0"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_3886_4164"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  >
                    <rect width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_3886_4164)">
                    <path
                      d="M5.85 17.1C6.7 16.45 7.65 15.9375 8.7 15.5625C9.75 15.1875 10.85 15 12 15C13.15 15 14.25 15.1875 15.3 15.5625C16.35 15.9375 17.3 16.45 18.15 17.1C18.7333 16.4167 19.1875 15.6417 19.5125 14.775C19.8375 13.9083 20 12.9833 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 12.9833 4.1625 13.9083 4.4875 14.775C4.8125 15.6417 5.26667 16.4167 5.85 17.1ZM12 13C11.0167 13 10.1875 12.6625 9.5125 11.9875C8.8375 11.3125 8.5 10.4833 8.5 9.5C8.5 8.51667 8.8375 7.6875 9.5125 7.0125C10.1875 6.3375 11.0167 6 12 6C12.9833 6 13.8125 6.3375 14.4875 7.0125C15.1625 7.6875 15.5 8.51667 15.5 9.5C15.5 10.4833 15.1625 11.3125 14.4875 11.9875C13.8125 12.6625 12.9833 13 12 13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C12.8833 20 13.7167 19.8708 14.5 19.6125C15.2833 19.3542 16 18.9833 16.65 18.5C16 18.0167 15.2833 17.6458 14.5 17.3875C13.7167 17.1292 12.8833 17 12 17C11.1167 17 10.2833 17.1292 9.5 17.3875C8.71667 17.6458 8 18.0167 7.35 18.5C8 18.9833 8.71667 19.3542 9.5 19.6125C10.2833 19.8708 11.1167 20 12 20ZM12 11C12.4333 11 12.7917 10.8583 13.075 10.575C13.3583 10.2917 13.5 9.93333 13.5 9.5C13.5 9.06667 13.3583 8.70833 13.075 8.425C12.7917 8.14167 12.4333 8 12 8C11.5667 8 11.2083 8.14167 10.925 8.425C10.6417 8.70833 10.5 9.06667 10.5 9.5C10.5 9.93333 10.6417 10.2917 10.925 10.575C11.2083 10.8583 11.5667 11 12 11Z"
                      fill="#1C1B1F"
                    />
                  </g>
                </svgre>
              </span> */}
              <span className="text_left">
                <strong>As Guest</strong> <br />{" "}
                <small
                  style={{ color: "rgb(144 144 144)", lineHeight: "normal" }}
                  className="block"
                >
                  Login and Check Bookings
                </small>
              </span>
              <svg
                width="17"
                height="17"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_6831_12431"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="17"
                  height="17"
                >
                  <rect width="15" height="15" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_6831_12431)">
                  <path
                    d="M10.3919 7.96839H3.28125C3.14823 7.96839 3.03687 7.92349 2.94719 7.8337C2.8574 7.74401 2.8125 7.63266 2.8125 7.49964C2.8125 7.36662 2.8574 7.25526 2.94719 7.16558C3.03687 7.07578 3.14823 7.03089 3.28125 7.03089H10.3919L7.16109 3.80011C7.06818 3.70719 7.02229 3.59844 7.02344 3.47386C7.02469 3.34927 7.07375 3.23849 7.17063 3.14151C7.2676 3.05099 7.3774 3.00412 7.5 3.00089C7.6226 2.99766 7.7324 3.04453 7.82938 3.14151L11.792 7.10417C11.8506 7.16271 11.8918 7.22443 11.9158 7.28933C11.9398 7.35422 11.9519 7.42433 11.9519 7.49964C11.9519 7.57495 11.9398 7.64505 11.9158 7.70995C11.8918 7.77485 11.8506 7.83657 11.792 7.89511L7.82938 11.8578C7.74281 11.9443 7.63563 11.9886 7.50781 11.9906C7.38 11.9926 7.2676 11.9483 7.17063 11.8578C7.07375 11.7608 7.02531 11.6494 7.02531 11.5237C7.02531 11.3979 7.07375 11.2865 7.17063 11.1895L10.3919 7.96839Z"
                    fill="#333333"
                  />
                </g>
              </svg>
            </Link>
            {/* )} */}
            <Link
              className="flex_align_center justify_content_between"
              // onClick={toggleSliderVendor}
              to="/login/vendor"
            >
              {/* <span className="supportSvg">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.25 13.75V3.25H3.25V0.25H10.75V6.25H13.75V13.75H7.75V10.75H6.25V13.75H0.25ZM1.75 12.25H3.25V10.75H1.75V12.25ZM1.75 9.25H3.25V7.75H1.75V9.25ZM1.75 6.25H3.25V4.75H1.75V6.25ZM4.75 9.25H6.25V7.75H4.75V9.25ZM4.75 6.25H6.25V4.75H4.75V6.25ZM4.75 3.25H6.25V1.75H4.75V3.25ZM7.75 9.25H9.25V7.75H7.75V9.25ZM7.75 6.25H9.25V4.75H7.75V6.25ZM7.75 3.25H9.25V1.75H7.75V3.25ZM10.75 12.25H12.25V10.75H10.75V12.25ZM10.75 9.25H12.25V7.75H10.75V9.25Z"
                    fill="#000"
                  />
                </svg>
              </span> */}
              <span className="text_left">
                <strong>As Product Partner</strong> <br />{" "}
                <small
                  style={{ color: "rgb(144 144 144)", lineHeight: "normal" }}
                  className="block"
                >
                  Handle Your Properties
                </small>
              </span>
              <svg
                width="17"
                height="17"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_6831_12431"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="17"
                  height="17"
                >
                  <rect width="15" height="15" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_6831_12431)">
                  <path
                    d="M10.3919 7.96839H3.28125C3.14823 7.96839 3.03687 7.92349 2.94719 7.8337C2.8574 7.74401 2.8125 7.63266 2.8125 7.49964C2.8125 7.36662 2.8574 7.25526 2.94719 7.16558C3.03687 7.07578 3.14823 7.03089 3.28125 7.03089H10.3919L7.16109 3.80011C7.06818 3.70719 7.02229 3.59844 7.02344 3.47386C7.02469 3.34927 7.07375 3.23849 7.17063 3.14151C7.2676 3.05099 7.3774 3.00412 7.5 3.00089C7.6226 2.99766 7.7324 3.04453 7.82938 3.14151L11.792 7.10417C11.8506 7.16271 11.8918 7.22443 11.9158 7.28933C11.9398 7.35422 11.9519 7.42433 11.9519 7.49964C11.9519 7.57495 11.9398 7.64505 11.9158 7.70995C11.8918 7.77485 11.8506 7.83657 11.792 7.89511L7.82938 11.8578C7.74281 11.9443 7.63563 11.9886 7.50781 11.9906C7.38 11.9926 7.2676 11.9483 7.17063 11.8578C7.07375 11.7608 7.02531 11.6494 7.02531 11.5237C7.02531 11.3979 7.07375 11.2865 7.17063 11.1895L10.3919 7.96839Z"
                    fill="#333333"
                  />
                </g>
              </svg>
            </Link>
          </div>
        )}
      </div>
      {loginPopup && <Login onClose={handleClose} />}

      {/* {isOpen && (
        <AgentLogin
          isOpen={isOpen}
          toggleSlider={toggleSlider}
          setIsOpen={setIsOpen}
        />
      )} */}
      {isCustomerOpen && (
        <CustomerLogin
          isOpen={isCustomerOpen}
          toggleSlider={toggleSliderCustomer}
          setIsOpen={setIsCustomerOpen}
        />
      )}
      {/* {isVendorOpen && (
        <VendorLogin
          isOpen={isVendorOpen}
          toggleSlider={toggleSliderVendor}
          setIsOpen={setIsVendorOpen}
        />
      )} */}
    </>
  );
}
export default NewUILoginBtn;
